export {
  default as coldPlunge,
  ReactComponent as ColdPlunge,
} from '@assets/icons/search/filters/cold-plunge.svg'    
